function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { clear as _clear, drawParticle as _drawParticle, drawParticlePlugin as _drawParticlePlugin, drawPlugin as _drawPlugin, paintBase, paintImage } from "../Utils/CanvasUtils";
import { deepExtend, isSsr } from "../Utils/Utils";
import { getStyleFromHsl, getStyleFromRgb, rangeColorToHsl, rangeColorToRgb } from "../Utils/ColorUtils";
import { generatedAttribute } from "./Utils/Constants";
function setTransformValue(factor, newFactor, key) {
  var newValue = newFactor[key];
  if (newValue !== undefined) {
    var _factor$key;
    factor[key] = ((_factor$key = factor[key]) !== null && _factor$key !== void 0 ? _factor$key : 1) * newValue;
  }
}
export var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    var _this = this;
    _classCallCheck(this, Canvas);
    this.container = container;
    this._applyPostDrawUpdaters = function (particle) {
      var _iterator = _createForOfIteratorHelper(_this._postDrawUpdaters),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var updater = _step.value;
          updater.afterDraw && updater.afterDraw(particle);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    this._applyPreDrawUpdaters = function (ctx, particle, radius, zOpacity, colorStyles, transform) {
      var _iterator2 = _createForOfIteratorHelper(_this._preDrawUpdaters),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var updater = _step2.value;
          if (updater.getColorStyles) {
            var _updater$getColorStyl = updater.getColorStyles(particle, ctx, radius, zOpacity),
              fill = _updater$getColorStyl.fill,
              stroke = _updater$getColorStyl.stroke;
            if (fill) {
              colorStyles.fill = fill;
            }
            if (stroke) {
              colorStyles.stroke = stroke;
            }
          }
          if (updater.getTransformValues) {
            var updaterTransform = updater.getTransformValues(particle);
            for (var key in updaterTransform) {
              setTransformValue(transform, updaterTransform, key);
            }
          }
          updater.beforeDraw && updater.beforeDraw(particle);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
    this._applyResizePlugins = function () {
      var _iterator3 = _createForOfIteratorHelper(_this._resizePlugins),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var plugin = _step3.value;
          plugin.resize && plugin.resize();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
    this._getPluginParticleColors = function (particle) {
      var fColor, sColor;
      var _iterator4 = _createForOfIteratorHelper(_this._colorPlugins),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var plugin = _step4.value;
          if (!fColor && plugin.particleFillColor) {
            fColor = rangeColorToHsl(plugin.particleFillColor(particle));
          }
          if (!sColor && plugin.particleStrokeColor) {
            sColor = rangeColorToHsl(plugin.particleStrokeColor(particle));
          }
          if (fColor && sColor) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return [fColor, sColor];
    };
    this._initCover = function () {
      var options = _this.container.actualOptions,
        cover = options.backgroundMask.cover,
        color = cover.color,
        coverRgb = rangeColorToRgb(color);
      if (coverRgb) {
        var coverColor = _objectSpread(_objectSpread({}, coverRgb), {}, {
          a: cover.opacity
        });
        _this._coverColorStyle = getStyleFromRgb(coverColor, coverColor.a);
      }
    };
    this._initStyle = function () {
      var element = _this.element,
        options = _this.container.actualOptions;
      if (!element) {
        return;
      }
      if (_this._fullScreen) {
        _this._originalStyle = deepExtend({}, element.style);
        _this._setFullScreenStyle();
      } else {
        _this._resetOriginalStyle();
      }
      for (var key in options.style) {
        if (!key || !options.style) {
          continue;
        }
        var value = options.style[key];
        if (!value) {
          continue;
        }
        element.style.setProperty(key, value, "important");
      }
    };
    this._initTrail = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var options, trail, trailFill, fillColor, _trail;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _this.container.actualOptions, trail = options.particles.move.trail, trailFill = trail.fill;
              if (trail.enable) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (!trailFill.color) {
                _context.next = 11;
                break;
              }
              fillColor = rangeColorToRgb(trailFill.color);
              if (fillColor) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              _trail = options.particles.move.trail;
              _this._trailFill = {
                color: _objectSpread({}, fillColor),
                opacity: 1 / _trail.length
              };
              _context.next = 13;
              break;
            case 11:
              _context.next = 13;
              return new Promise(function (resolve, reject) {
                if (!trailFill.image) {
                  return;
                }
                var img = document.createElement("img");
                img.addEventListener("load", function () {
                  _this._trailFill = {
                    image: img,
                    opacity: 1 / trail.length
                  };
                  resolve();
                });
                img.addEventListener("error", function (evt) {
                  reject(evt.error);
                });
                img.src = trailFill.image;
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    this._paintBase = function (baseColor) {
      _this.draw(function (ctx) {
        return paintBase(ctx, _this.size, baseColor);
      });
    };
    this._paintImage = function (image, opacity) {
      _this.draw(function (ctx) {
        return paintImage(ctx, _this.size, image, opacity);
      });
    };
    this._repairStyle = function () {
      var element = _this.element;
      if (!element) {
        return;
      }
      _this._safeMutationObserver(function (observer) {
        return observer.disconnect();
      });
      _this._initStyle();
      _this.initBackground();
      _this._safeMutationObserver(function (observer) {
        return observer.observe(element, {
          attributes: true
        });
      });
    };
    this._resetOriginalStyle = function () {
      var element = _this.element,
        originalStyle = _this._originalStyle;
      if (!(element && originalStyle)) {
        return;
      }
      var style = element.style;
      style.position = originalStyle.position;
      style.zIndex = originalStyle.zIndex;
      style.top = originalStyle.top;
      style.left = originalStyle.left;
      style.width = originalStyle.width;
      style.height = originalStyle.height;
    };
    this._safeMutationObserver = function (callback) {
      if (!_this._mutationObserver) {
        return;
      }
      callback(_this._mutationObserver);
    };
    this._setFullScreenStyle = function () {
      var element = _this.element;
      if (!element) {
        return;
      }
      var priority = "important",
        style = element.style;
      style.setProperty("position", "fixed", priority);
      style.setProperty("z-index", _this.container.actualOptions.fullScreen.zIndex.toString(10), priority);
      style.setProperty("top", "0", priority);
      style.setProperty("left", "0", priority);
      style.setProperty("width", "100%", priority);
      style.setProperty("height", "100%", priority);
    };
    this.size = {
      height: 0,
      width: 0
    };
    this._context = null;
    this._generated = false;
    this._preDrawUpdaters = [];
    this._postDrawUpdaters = [];
    this._resizePlugins = [];
    this._colorPlugins = [];
    this._mutationObserver = !isSsr() && typeof MutationObserver !== "undefined" ? new MutationObserver(function (records) {
      var _iterator5 = _createForOfIteratorHelper(records),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var record = _step5.value;
          if (record.type === "attributes" && record.attributeName === "style") {
            _this._repairStyle();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }) : undefined;
  }
  _createClass(Canvas, [{
    key: "_fullScreen",
    get: function get() {
      return this.container.actualOptions.fullScreen.enable;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      var options = this.container.actualOptions,
        trail = options.particles.move.trail,
        trailFill = this._trailFill;
      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && trailFill) {
        if (trailFill.color) {
          this._paintBase(getStyleFromRgb(trailFill.color, trailFill.opacity));
        } else if (trailFill.image) {
          this._paintImage(trailFill.image, trailFill.opacity);
        }
      } else {
        this.draw(function (ctx) {
          _clear(ctx, _this2.size);
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._safeMutationObserver(function (obs) {
        return obs.disconnect();
      });
      if (this._generated) {
        var element = this.element;
        element && element.remove();
      } else {
        this._resetOriginalStyle();
      }
      this.stop();
      this._preDrawUpdaters = [];
      this._postDrawUpdaters = [];
      this._resizePlugins = [];
      this._colorPlugins = [];
    }
  }, {
    key: "draw",
    value: function draw(cb) {
      var ctx = this._context;
      if (!ctx) {
        return;
      }
      return cb(ctx);
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _particle$getStrokeCo,
        _this3 = this;
      if (particle.spawning || particle.destroyed) {
        return;
      }
      var radius = particle.getRadius();
      if (radius <= 0) {
        return;
      }
      var pfColor = particle.getFillColor(),
        psColor = (_particle$getStrokeCo = particle.getStrokeColor()) !== null && _particle$getStrokeCo !== void 0 ? _particle$getStrokeCo : pfColor;
      var _this$_getPluginParti = this._getPluginParticleColors(particle),
        _this$_getPluginParti2 = _slicedToArray(_this$_getPluginParti, 2),
        fColor = _this$_getPluginParti2[0],
        sColor = _this$_getPluginParti2[1];
      if (!fColor) {
        fColor = pfColor;
      }
      if (!sColor) {
        sColor = psColor;
      }
      if (!fColor && !sColor) {
        return;
      }
      this.draw(function (ctx) {
        var _ref2, _particle$bubble$opac, _particle$opacity, _particle$strokeOpaci;
        var container = _this3.container,
          options = container.actualOptions,
          zIndexOptions = particle.options.zIndex,
          zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate),
          opacity = (_ref2 = (_particle$bubble$opac = particle.bubble.opacity) !== null && _particle$bubble$opac !== void 0 ? _particle$bubble$opac : (_particle$opacity = particle.opacity) === null || _particle$opacity === void 0 ? void 0 : _particle$opacity.value) !== null && _ref2 !== void 0 ? _ref2 : 1,
          strokeOpacity = (_particle$strokeOpaci = particle.strokeOpacity) !== null && _particle$strokeOpaci !== void 0 ? _particle$strokeOpaci : opacity,
          zOpacity = opacity * zOpacityFactor,
          zStrokeOpacity = strokeOpacity * zOpacityFactor,
          transform = {},
          colorStyles = {
            fill: fColor ? getStyleFromHsl(fColor, zOpacity) : undefined
          };
        colorStyles.stroke = sColor ? getStyleFromHsl(sColor, zStrokeOpacity) : colorStyles.fill;
        _this3._applyPreDrawUpdaters(ctx, particle, radius, zOpacity, colorStyles, transform);
        _drawParticle({
          container: container,
          context: ctx,
          particle: particle,
          delta: delta,
          colorStyles: colorStyles,
          backgroundMask: options.backgroundMask.enable,
          composite: options.backgroundMask.composite,
          radius: radius * Math.pow(1 - particle.zIndexFactor, zIndexOptions.sizeRate),
          opacity: zOpacity,
          shadow: particle.options.shadow,
          transform: transform
        });
        _this3._applyPostDrawUpdaters(particle);
      });
    }
  }, {
    key: "drawParticlePlugin",
    value: function drawParticlePlugin(plugin, particle, delta) {
      this.draw(function (ctx) {
        return _drawParticlePlugin(ctx, plugin, particle, delta);
      });
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      this.draw(function (ctx) {
        return _drawPlugin(ctx, plugin, delta);
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.resize();
                this._initStyle();
                this._initCover();
                _context2.prev = 3;
                _context2.next = 6;
                return this._initTrail();
              case 6:
                _context2.next = 11;
                break;
              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);
                console.error(_context2.t0);
              case 11:
                this.initBackground();
                this._safeMutationObserver(function (obs) {
                  if (!_this4.element) {
                    return;
                  }
                  obs.observe(_this4.element, {
                    attributes: true
                  });
                });
                this.initUpdaters();
                this.initPlugins();
                this.paint();
              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.actualOptions,
        background = options.background,
        element = this.element;
      if (!element) {
        return;
      }
      var elementStyle = element.style;
      if (!elementStyle) {
        return;
      }
      if (background.color) {
        var color = rangeColorToRgb(background.color);
        elementStyle.backgroundColor = color ? getStyleFromRgb(color, background.opacity) : "";
      } else {
        elementStyle.backgroundColor = "";
      }
      elementStyle.backgroundImage = background.image || "";
      elementStyle.backgroundPosition = background.position || "";
      elementStyle.backgroundRepeat = background.repeat || "";
      elementStyle.backgroundSize = background.size || "";
    }
  }, {
    key: "initPlugins",
    value: function initPlugins() {
      this._resizePlugins = [];
      var _iterator6 = _createForOfIteratorHelper(this.container.plugins),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref5 = _step6.value;
          var _ref4 = _slicedToArray(_ref5, 2);
          var plugin = _ref4[1];
          if (plugin.resize) {
            this._resizePlugins.push(plugin);
          }
          if (plugin.particleFillColor || plugin.particleStrokeColor) {
            this._colorPlugins.push(plugin);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "initUpdaters",
    value: function initUpdaters() {
      this._preDrawUpdaters = [];
      this._postDrawUpdaters = [];
      var _iterator7 = _createForOfIteratorHelper(this.container.particles.updaters),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var updater = _step7.value;
          if (updater.afterDraw) {
            this._postDrawUpdaters.push(updater);
          }
          if (updater.getColorStyles || updater.getTransformValues || updater.beforeDraw) {
            this._preDrawUpdaters.push(updater);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas) {
      var _this5 = this;
      if (this._generated && this.element) {
        this.element.remove();
      }
      this._generated = canvas.dataset && generatedAttribute in canvas.dataset ? canvas.dataset[generatedAttribute] === "true" : this._generated;
      this.element = canvas;
      this.element.ariaHidden = "true";
      this._originalStyle = deepExtend({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this._context = this.element.getContext("2d");
      this._safeMutationObserver(function (obs) {
        if (!_this5.element) {
          return;
        }
        obs.observe(_this5.element, {
          attributes: true
        });
      });
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this6 = this;
      var options = this.container.actualOptions;
      this.draw(function (ctx) {
        if (options.backgroundMask.enable && options.backgroundMask.cover) {
          _clear(ctx, _this6.size);
          _this6._paintBase(_this6._coverColorStyle);
        } else {
          _this6._paintBase();
        }
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return false;
      }
      var container = this.container,
        pxRatio = container.retina.pixelRatio,
        size = container.canvas.size,
        newSize = {
          width: this.element.offsetWidth * pxRatio,
          height: this.element.offsetHeight * pxRatio
        };
      if (newSize.height === size.height && newSize.width === size.width && newSize.height === this.element.height && newSize.width === this.element.width) {
        return false;
      }
      var oldSize = _objectSpread({}, size);
      this.element.width = size.width = this.element.offsetWidth * pxRatio;
      this.element.height = size.height = this.element.offsetHeight * pxRatio;
      if (this.container.started) {
        this.resizeFactor = {
          width: size.width / oldSize.width,
          height: size.height / oldSize.height
        };
      }
      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this7 = this;
      this.draw(function (ctx) {
        return _clear(ctx, _this7.size);
      });
    }
  }, {
    key: "windowResize",
    value: function () {
      var _windowResize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var container, needsRefresh;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.element || !this.resize())) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                container = this.container, needsRefresh = container.updateActualOptions();
                container.particles.setDensity();
                this._applyResizePlugins();
                if (!needsRefresh) {
                  _context3.next = 8;
                  break;
                }
                _context3.next = 8;
                return container.refresh();
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function windowResize() {
        return _windowResize.apply(this, arguments);
      }
      return windowResize;
    }()
  }]);
  return Canvas;
}();